import { render } from "./RegisterPanel.vue?vue&type=template&id=184d59bc&scoped=true"
import script from "./RegisterPanel.vue?vue&type=script&lang=js"
export * from "./RegisterPanel.vue?vue&type=script&lang=js"

import "./RegisterPanel.vue?vue&type=style&index=0&id=184d59bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184d59bc"]])

export default __exports__